var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Criação" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Tipo de criação",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: !_vm.pratica.criacoes.length ? "required" : "",
              opcoes: _vm.slct.opcoesTipoCriacao,
              widthColumn: _vm.containsOption(
                _vm.criacoes.tipoCriacao,
                "OUTROS",
                "criacoes.outrasCriacoes",
                true
              )
                ? 6
                : 8
            },
            model: {
              value: _vm.criacoes.tipoCriacao,
              callback: function($$v) {
                _vm.$set(_vm.criacoes, "tipoCriacao", $$v)
              },
              expression: "criacoes.tipoCriacao"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.criacoes.tipoCriacao,
            "OUTROS",
            "criacoes.outrasCriacoes",
            true
          )
            ? _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: !_vm.pratica.criacoes.length ? "required" : "",
                      mode: "lazy",
                      name: _vm.nomeAba + "/Outros"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("Label", {
                                attrs: {
                                  label: "Outros",
                                  obrigatorio: !_vm.pratica.criacoes.length
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outros", clearable: "" },
                                model: {
                                  value: _vm.criacoes.outrasCriacoes,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.criacoes,
                                      "outrasCriacoes",
                                      $$v
                                    )
                                  },
                                  expression: "criacoes.outrasCriacoes"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3799407082
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-col",
            {
              attrs: {
                span: _vm.containsOption(
                  _vm.criacoes.tipoCriacao,
                  "OUTROS",
                  "criacoes.outrasCriacoes",
                  true
                )
                  ? 6
                  : 8
              }
            },
            [
              _c("validation-provider", {
                attrs: {
                  rules: !_vm.pratica.criacoes.length ? "required" : "",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Número de animais"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("Label", {
                          attrs: {
                            label: "Número de animais",
                            obrigatorio: !_vm.pratica.criacoes.length
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: { name: "Número de animais", clearable: "" },
                          model: {
                            value: _vm.criacoes.numeroAnimais,
                            callback: function($$v) {
                              _vm.$set(_vm.criacoes, "numeroAnimais", $$v)
                            },
                            expression: "criacoes.numeroAnimais"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              attrs: {
                span: _vm.containsOption(
                  _vm.criacoes.tipoCriacao,
                  "OUTROS",
                  "outrasCriacoes",
                  true
                )
                  ? 6
                  : 8
              }
            },
            [
              _c("validation-provider", {
                attrs: {
                  rules: !_vm.pratica.criacoes.length ? "required" : "",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Data de início"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("Label", {
                          attrs: {
                            label: "Data de início",
                            obrigatorio: !_vm.pratica.criacoes.length
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: {
                            name: "Data de início",
                            type: "month",
                            placeholder: "Selecione mês e ano",
                            format: "MM/yyyy",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.criacoes.dataInicio,
                            callback: function($$v) {
                              _vm.$set(_vm.criacoes, "dataInicio", $$v)
                            },
                            expression: "criacoes.dataInicio"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            width: "100%",
            top: "20px",
            display: "flex",
            "justify-content": "flex-end"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.disableButton,
                round: "",
                type: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.btnAdicionar()
                }
              }
            },
            [_vm._v("\n      Adicionar\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
        _vm._l(_vm.pratica.criacoes, function(c, i) {
          return _c(
            "div",
            { key: i + c.tipoCriacao },
            [
              _c("Card", {
                attrs: {
                  objeto: Object.assign({}, c, {
                    dataInicio: _vm.formataStringYearMonthToBr(c.dataInicio),
                    tipoCriacao: _vm.pratica.criacoes
                      ? _vm.slct.opcoesTipoCriacao.find(function(criacao) {
                          return criacao.id === c.tipoCriacao
                        }).nome
                      : "-"
                  }),
                  deletar: function() {
                    return _vm.btnApagar(i)
                  },
                  editar: function() {
                    return _vm.btnEditar(c, i)
                  },
                  titulo: "Tipo de criação"
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "Manejo" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Tipo de manejo predominante",
              nomeAba: _vm.nomeAba,
              obrigatorio: "",
              rulesInput: "required",
              opcoes: _vm.slct.opcoesTipoManejo,
              widthColumn: 12,
              multiSelect: ""
            },
            model: {
              value: _vm.pratica.tiposManejo,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "tiposManejo", $$v)
              },
              expression: "pratica.tiposManejo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "Tratamento de resíduos" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Tipo de tratamento",
              nomeAba: _vm.nomeAba,
              obrigatorio: "",
              rulesInput: "required",
              opcoes: _vm.slct.opcoesTipoTratamento,
              widthColumn: 12,
              multiSelect: ""
            },
            model: {
              value: _vm.pratica.tiposTratamento,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "tiposTratamento", $$v)
              },
              expression: "pratica.tiposTratamento"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.pratica.tiposTratamento,
            "OUTROS",
            "outrosTiposTratamento"
          )
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Outros tipos de tratamento"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("Label", {
                                attrs: { label: "Quais?", obrigatorio: "" }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outros tipos de tratamento" },
                                model: {
                                  value: _vm.pratica.outrosTiposTratamento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pratica,
                                      "outrosTiposTratamento",
                                      $$v
                                    )
                                  },
                                  expression: "pratica.outrosTiposTratamento"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3885747603
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Aproveitamento do resíduo tratado",
              nomeAba: _vm.nomeAba,
              obrigatorio: "",
              rulesInput: "required",
              opcoes: _vm.slct.opcoesAproveitamentoResiduos,
              widthColumn: 12,
              multiSelect: ""
            },
            model: {
              value: _vm.pratica.tiposAproveitamentoResiduos,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "tiposAproveitamentoResiduos", $$v)
              },
              expression: "pratica.tiposAproveitamentoResiduos"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.pratica.tiposAproveitamentoResiduos,
            "OUTROS",
            "outrosTiposAproveitamentoResiduos"
          )
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name:
                    _vm.nomeAba + "/Outros tipos de aproveitamento de resíduos"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("Label", {
                                attrs: { label: "Quais?", obrigatorio: "" }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: {
                                  name:
                                    "Outros tipos de aproveitamento de resíduos"
                                },
                                model: {
                                  value:
                                    _vm.pratica
                                      .outrosTiposAproveitamentoResiduos,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pratica,
                                      "outrosTiposAproveitamentoResiduos",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pratica.outrosTiposAproveitamentoResiduos"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2860045078
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "Financiamento" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Fonte de financiamento para implementação da prática",
              nomeAba: _vm.nomeAba,
              obrigatorio: "",
              rulesInput: "required",
              opcoes: _vm.slct.opcoesFonteFinanciamento,
              widthColumn: 12,
              multiSelect: ""
            },
            model: {
              value: _vm.pratica.financiamentos,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "financiamentos", $$v)
              },
              expression: "pratica.financiamentos"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.pratica.financiamentos,
            "OUTRO",
            "outroFinanciamento"
          )
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Outros tipos de fonte de financiamento"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("Label", {
                                attrs: { label: "Quais?", obrigatorio: "" }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: {
                                  name: "Outros tipos de fonte de financiamento"
                                },
                                model: {
                                  value: _vm.pratica.outroFinanciamento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pratica,
                                      "outroFinanciamento",
                                      $$v
                                    )
                                  },
                                  expression: "pratica.outroFinanciamento"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2319983174
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: { mode: "lazy", name: _vm.nomeAba + "/Descrição" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("Label", { attrs: { label: "Descrição" } }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Descrição",
                            type: "textarea",
                            maxlength: "500",
                            "show-word-limit": ""
                          },
                          model: {
                            value: _vm.pratica.descricao,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "descricao", $$v)
                            },
                            expression: "pratica.descricao"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7453d157", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7453d157","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/MRPA/MRPA.vue
// module id = null
// module chunks = 